import React, { useState, useEffect, useRef } from "react";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import DeletePopup from "../Common/DeletePopup";
import {
  uploadFileViaMultipart,
  removeFile,
} from "../../Actions/uploadFileActions";
import { useDispatch } from "react-redux";
import CustomPopUp from "../Common/customPopUp";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";

function PVSingleFileUpload({
  name,
  id,
  title,
  subheading,
  record,
  placeholder,
  fieldId,
  isRequired,
  getCount,
  totalCount,
  getUpdatedPvData,
  reRenderAgain2,
  errId,
  hasError = false,
}) {
  const dispatch = useDispatch();
  const [fileLength, setFileLength] = useState();
  const [showModal, setShowModal] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(0);

  console.log("er", record);
  const uploadFile = async (event) => {
    const chosenFiles = event.target.files;

    for (var i = 0; i < chosenFiles.length; i++) {
      if (event.target.files[0].size > 5242880) {
        alert("File size exceed 5mb");
        return false;
      }
      if (
        chosenFiles[i].name.split(".").pop() == "png" ||
        chosenFiles[i].name.split(".").pop() == "PNG" ||
        chosenFiles[i].name.split(".").pop() == "jpg" ||
        chosenFiles[i].name.split(".").pop() == "JPG" ||
        chosenFiles[i].name.split(".").pop() == "jpeg" ||
        chosenFiles[i].name.split(".").pop() == "JPEG" ||
        chosenFiles[i].name.split(".").pop() == "pdf" ||
        chosenFiles[i].name.split(".").pop() == "PDF"
      ) {
        // props.errorCheck("false");
        // return false;
      } else {
        alert("Invalid file format");
        //props.errorCheck("true");
        return false;
      }
    }

    // let err_id = errId;
    //   document.getElementById(err_id).innerHTML = '';
    await dispatch(
      uploadFileViaMultipart("pv_check_documents", chosenFiles, record)
    );
    // reRenderAgain2();
    getUpdatedPvData();
  };

  const closeModal = () => {
    setShowModal(0);
  };

  const openModal = () => {
    setShowModal(1);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(0);
  };

  const deleteHandler = () => {
    setShowDeleteModal(1);
  };

  const proceedDelete = async () => {
    const recordArray = {};
    //alert("d");
    recordArray.doc_chk = record.caseCheckId;
    recordArray.doc_ids = record.docId;
    recordArray.doc_side = record.docside;
    recordArray.doc_ref = "all";
    if(record["fldid"] !== undefined){
    recordArray.fldid = record.fldid;
    }
    dispatch(removeFile("check_documents", recordArray));
    getUpdatedPvData();
    //reRenderAgain2();
    setShowDeleteModal(0);
    // getUpdatedPvData();
  };

  return (
    <>
      {/* {isLoading && <Loader />} */}
      <div className="row mt-3">
        <div className="col-sm-12 col-md-12 col-xl-12">
          <h6 className="fnt-smi-bld mb-0">
            {title} <small class="fnt-inter-mdum">{subheading}</small>{" "}
            {isRequired == 1 && <sup className="text-danger">*</sup>}
          </h6>
          <p></p>
        </div>
        <div className="col-sm-4 col-md-12 col-xl-4">
          <label htmlFor={id} className="upload-box mb-0 flex-column pt-1 pb-1">
            <img src={UploadIcon} className="mb-2" alt="" />

            <label class="mb-0 text-center" style={{ lineHeight: "16px" }}>
              <div className="right text-right w-100">
                <div className="position-relative">
                  <input
                    id={id}
                    type="file"
                    style={{ opacity: "0", width: "100%" }}
                    // accept="image/*"
                    multiple
                    onChange={(e) => uploadFile(e)}
                    onClick={e => (e.target.value = null)}
                    // accept="image/png, image/jpeg, application/pdf"
                    title="Choose Files"
                    // params => caseCheckId, docId
                    // onChange={(e) => uploadFile(e)}
                  ></input>

                  {/* <img src={CrossIcon} alt="" className="remove-btn" /> */}
                </div>
              </div>
              <small class="text-center fnt-smi-bld">
                <span className="text-primary">Click to upload</span>
                {/* <span className="text-muted">or drag and drop</span> */}
                <br />
                <span className="text-muted">
                  PDF, PNG, JPG, or JPEG <br />
                  Max file size : 5 MB
                </span>
              </small>
            </label>
          </label>

          <p className="err text-danger" id={errId}>
            {hasError === true && <>This field is required </>}
          </p>
        </div>

        {/* {
  "col-auto d-flex align-items-center actions-mbl " + (count >= 1 ? "show" : "hidden")
} */}

        {/* <div className= {
  "col-auto d-flex align-items-center actions-mbl " + (getCount >= 1 ? "show" : "hidden")
} id={`doc_${record.docId}`}> */}

        {totalCount > 0 && (
          <div
            className={"col-sm-4 col-md-12 col-xl-4"}
            id={`doc_${record.docId}`}
          >
            {/* {(count >= 1) &&  */}
            <>
              <h6>&nbsp;</h6>
              <div className="after-upload-box w-100">
                {totalCount > 0 && (
                  <div>
                    <i class="far fa-file mr-3"></i>
                    <small className="fnt-smi-bld">
                      {totalCount} files uploaded
                    </small>
                  </div>
                )}{" "}
                <div>
                  <i
                    class="fas fa-eye text-muted mr-3 cursor-pointer"
                    onClick={openModal}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="View"
                  ></i>
                  <i
                    class="fas fa-trash-alt text-muted text-danger cursor-pointer"
                    onClick={deleteHandler}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Delete"
                  ></i>
                </div>
              </div>
            </>

            {/* }      */}
          </div>
        )}
      </div>

      {showDeleteModal === 1 && (
        <DeletePopup
          showModalBox={showDeleteModal}
          closePopup={closeDeleteModal}
          title="Delete Images"
          description="Are you sure you want to delete? This action cannot be undone."
          proceedHandler={proceedDelete}
          // record={record}
        />
      )}

      {showModal === 1 && (
        <CustomPopUp
          showModalBox={showModal}
          closePopup={closeModal}
          record={record}
          title={title}
          reRenderAgain={getUpdatedPvData}
        //  getUpdatedPvData={getUpdatedPvData}
        />
      )}
    </>
  );
}

export default PVSingleFileUpload;
